import React from 'react';
import {FormikSwitcher} from '@tickchak/react-share/app';
import * as css from '../TicketValidity.css';
import DateTimeInputPair from './DateTimeInputPair';

interface ValiditySectionProps {
    title: string;
    subtitle: string;
    enabledFieldName: string;
    dateFieldName: string;
    timeFieldName: string;
    dateLabel: string;
    timeLabel: string;
    isEnabled: boolean;
    activeLabel: string;
    inActiveLabel: string;
}

function ValiditySection({
    title,
    subtitle,
    enabledFieldName,
    dateFieldName,
    timeFieldName,
    dateLabel,
    timeLabel,
    isEnabled,
    activeLabel,
    inActiveLabel
}: ValiditySectionProps) {
    return (
        <css.section>
            <css.sectionHeader>
                <css.titleWrapper>
                    <css.title>{title}</css.title>
                    <css.subtitle>{subtitle}</css.subtitle>
                </css.titleWrapper>
                <FormikSwitcher
                    name={enabledFieldName}
                    label={{
                        on: activeLabel,
                        off: inActiveLabel,
                        show: true
                    }}
                />
            </css.sectionHeader>
            {isEnabled && (
                <DateTimeInputPair
                    dateFieldName={dateFieldName}
                    timeFieldName={timeFieldName}
                    dateLabel={dateLabel}
                    timeLabel={timeLabel}
                    isEnabled={isEnabled}
                />
            )}
        </css.section>
    );
}

export default ValiditySection;
